import type { FC, SVGAttributes } from 'react';
import React from 'react';

export const IconSearchLight: FC<SVGAttributes<SVGElement>> = props => (
    <svg height="16" viewBox="0 0 16 16" width="16" {...props}>
        <path
            d="M6.5 13a6.47 6.47 0 004.072-1.441l3.737 3.737a.699.699 0 00.987-.987l-3.737-3.737A6.468 6.468 0 0013 6.5C13 2.916 10.084 0 6.5 0A6.508 6.508 0 000 6.5C0 10.084 2.916 13 6.5 13zm0-12C9.533 1 12 3.468 12 6.5S9.533 12 6.5 12A5.506 5.506 0 011 6.5C1 3.468 3.467 1 6.5 1z"
            fill="currentColor"
        />
    </svg>
);
